export default "__VITE_ASSET__7DrwIIoK__"